import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.q5g().n50() : headers;
  return DelegatedCall().k5i(_this__u8e3s4.l5g_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      static k5i(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.q5g().n50() : responseHeaders;
        var $this = this.l5i(client);
        $this.n5g_1 = new (DelegatedRequest())($this, originCall.m5i());
        $this.o5g_1 = new (DelegatedResponse())($this, originCall.q5g(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.r5i_1 = origin;
        this.s5i_1 = call;
      }
      t5i() {
        return this.s5i_1;
      }
      ew() {
        return this.r5i_1.ew();
      }
      u5i() {
        return this.r5i_1.u5i();
      }
      v5i() {
        return this.r5i_1.v5i();
      }
      n5i() {
        return this.r5i_1.n5i();
      }
      t2o() {
        return this.r5i_1.t2o();
      }
      n50() {
        return this.r5i_1.n50();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.n50() : headers;
        super();
        this.w5i_1 = call;
        this.x5i_1 = origin;
        this.y5i_1 = content;
        this.z5i_1 = headers;
        this.a5j_1 = this.x5i_1.ew();
      }
      t5i() {
        return this.w5i_1;
      }
      n50() {
        return this.z5i_1;
      }
      b5j() {
        return this.y5i_1(this.x5i_1);
      }
      ew() {
        return this.a5j_1;
      }
      c5j() {
        return this.x5i_1.c5j();
      }
      d5j() {
        return this.x5i_1.d5j();
      }
      e5j() {
        return this.x5i_1.e5j();
      }
      f5j() {
        return this.x5i_1.f5j();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
